<p-card header="ABI Graphs">
    <p-dropdown [options]="abis" [(ngModel)]="selectedABI" optionLabel="name" (onChange)="populateGraphs($event.value.code)"></p-dropdown>
    <div *ngIf="loading" class="flex-1 p-4">
        <p-progressSpinner></p-progressSpinner>
    </div>
    <div *ngIf="!loading">
        <p-card header="Tet">
            <p-chart type="line" [data]="tetData" [options]="options"></p-chart>
        </p-card>
    </div>
    <div *ngIf="!loading">
        <p-card header="Rox">
            <p-chart type="line" [data]="roxData" [options]="options"></p-chart>
        </p-card>
    </div>
    <div *ngIf="!loading">
        <p-card header="Fam">
            <p-chart type="line" [data]="famData" [options]="options"></p-chart>
        </p-card>
    </div>
</p-card>
